import React, { useContext, useMemo } from 'react';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { UnitsContext } from '../../../../Contexts/UnitsContext';
import CreateUnitModalContent from './CreateUnitModalContent';
import { Modalv2Context } from '../../../../Contexts/Modalv2Context';
import { EXPB_DOC_CONSTANTS } from '../../../../core/constants';
import GeneralIconButton from '../../../../Components/GeneralIconButton';
import InfoButton from '../../../../Components/InfoButton';
import { UnitLabel } from './UnitLabel';

//mui imports====
import { Box } from '@mui/system';
import useStyles from '../../styles';
import useCommonStyles from '../../../../commonStyles';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SyncIcon from '@mui/icons-material/Sync';
import SyncLockIcon from '@mui/icons-material/SyncLock';
import UpdateIcon from '@mui/icons-material/Update';
import UpdateDisabledIcon from '@mui/icons-material/UpdateDisabled';

const {
	BLOCKERS: { SITE_SYNC, SITE_UPDATE }
} = EXPB_DOC_CONSTANTS;

const UnitCreatorUi = () => {
	//this component renders as position:fixed component at the right of navbar
	const { updateModalContent } = useContext(Modalv2Context);
	const { expbDoc } = useContext(UnitsContext);
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();

	const getSyncIcon = () => {
		if (expbDoc && Array.isArray(expbDoc.blockers) && expbDoc.blockers.includes(SITE_SYNC)) {
			return (
				<SyncLockIcon
					className={commonStyleClasses.icon}
					fontSize="medium"
					style={{ margin: '2rem', color: 'red' }}
				/>
			);
		}
		return (
			<SyncIcon
				className={commonStyleClasses.icon}
				fontSize="medium"
				style={{ margin: '2rem', color: 'green' }}
			/>
		);
	};

	const getSRInfoIcon = () => {
		const isSRSite = expbDoc?.consumerConfigs?.length > 0;
		if (!isSRSite) {
			return '';
		}
		const infoMessage = "Site is Selectively Rolled out!";
		const infoButtonProps = { iconSize: 'large', iconColor: 'red' };
		return <InfoButton message={infoMessage} {...infoButtonProps} />;
	};

	const getSiteUpdateIcon = () => {
		if (expbDoc && Array.isArray(expbDoc.blockers) && expbDoc.blockers.includes(SITE_UPDATE)) {
			return (
				<UpdateDisabledIcon
					className={commonStyleClasses.icon}
					fontSize="medium"
					style={{ margin: '2rem', color: 'red' }}
				/>
			);
		}
		return (
			<UpdateIcon
				className={commonStyleClasses.icon}
				fontSize="medium"
				style={{ margin: '2rem', color: 'green' }}
			/>
		);
	};

	return (
		<Box className={classes.unitCreatorUi}>
			<DropDown label="Unit Id" />

			<GeneralIconButton
				className={commonStyleClasses.icon}
				color="primary"
				fontSize="medium"
				style={{ margin: '0 1rem 0 2rem' }}
				onClick={() => {
					updateModalContent(<CreateUnitModalContent />);
				}}
				name={'INST_OPEN_CREATE_UNIT_MODAL'}
			>
				<AddCircleOutlineOutlinedIcon style={{ marginTop: '-.5rem' }} />
			</GeneralIconButton>
			<Box style={{ margin: '0 2rem', display: 'flex' }}>
				{getSiteUpdateIcon()}
				{getSyncIcon()}
				{getSRInfoIcon()}
			</Box>
		</Box>
	);
};

const DropDown = () => {
	const { updateSelectedUnit, curSelectedUnit, units, nonArchivedUnitsArray } =
		useContext(UnitsContext);
	const classes = useStyles();

	const unitsArray = useMemo(() => {
		return nonArchivedUnitsArray.map((sectionRef) => {
			return {
				sectionRef,
				videoSectionId: units[sectionRef].videoSectionId,
				name: units[sectionRef].name,
				multiSplitTestData: units[sectionRef].multiSplitTestData
			};
		});
	}, [units, nonArchivedUnitsArray]);

	return (
		<FormControl className={classes.sectionSwitchDropDown}>
			<Select
				value={curSelectedUnit}
				onChange={(e) => {
					updateSelectedUnit(e.target.value);
				}}
				variant="outlined"
				autoFocus={false}
				style={{ width: '50rem', height: '100%' }}
				sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
			>
				{unitsArray &&
					unitsArray.map((unitData) => {
						return (
							<MenuItem value={unitData.sectionRef} key={unitData.sectionRef}>
								<UnitLabel unitData={unitData} />
							</MenuItem>
						);
					})}
			</Select>
		</FormControl>
	);
};

export default UnitCreatorUi;
